import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Home/museum.png'
import _imports_1 from '@/assets/Home/prologram.png'
import _imports_2 from '@/assets/Home/cutie_trick.png'


const _withScopeId = n => (_pushScopeId("data-v-79b957cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"calc(100vh - 64px)"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner_link" }, null, -1))

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleView',
  setup(__props) {

var slide = ref(1)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_q_page, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_carousel, {
            animated: "",
            modelValue: _unref(slide),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(slide) ? (slide).value = $event : slide = $event)),
            navigation: "",
            infinite: "",
            autoplay: 5000,
            "transition-prev": "slide-right",
            "transition-next": "slide-left",
            style: {"height":"100%"}
          }, {
            "navigation-icon": _withCtx(({ active, btnProps, onClick }) => [
              active
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    size: "5pt",
                    icon: btnProps.icon,
                    color: "primary",
                    flat: "",
                    round: "",
                    dense: "",
                    onClick: onClick
                  }, null, 8, ["icon", "onClick"]))
                : (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    size: "5pt",
                    icon: btnProps.icon,
                    color: "white",
                    flat: "",
                    round: "",
                    dense: "",
                    onClick: onClick
                  }, null, 8, ["icon", "onClick"]))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_carousel_slide, {
                name: 1,
                "img-src": _imports_0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "works/museum" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_carousel_slide, {
                name: 2,
                "img-src": _imports_1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "works/prologram" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_carousel_slide, {
                name: 3,
                "img-src": _imports_2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "works/cutie_trick" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_router_link, {
            to: "works/museum",
            class: "link"
          })
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.$q.platform.is.desktop]
    ]),
    _withDirectives(_createVNode(_component_q_carousel, {
      animated: "",
      modelValue: _unref(slide),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(slide) ? (slide).value = $event : slide = $event)),
      navigation: "",
      infinite: "",
      autoplay: 5000,
      "transition-prev": "slide-right",
      "transition-next": "slide-left",
      height: "30vh"
    }, {
      "navigation-icon": _withCtx(({ active, btnProps, onClick }) => [
        active
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              size: "5pt",
              icon: btnProps.icon,
              color: "primary",
              flat: "",
              round: "",
              dense: "",
              onClick: onClick
            }, null, 8, ["icon", "onClick"]))
          : (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              size: "5pt",
              icon: btnProps.icon,
              color: "white",
              flat: "",
              round: "",
              dense: "",
              onClick: onClick
            }, null, 8, ["icon", "onClick"]))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_q_carousel_slide, {
          name: 1,
          "img-src": _imports_0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "works/museum" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_carousel_slide, {
          name: 2,
          "img-src": _imports_1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "works/prologram" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_carousel_slide, {
          name: 3,
          "img-src": _imports_2
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "works/cutie_trick" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]), [
      [_vShow, _ctx.$q.platform.is.mobile]
    ])
  ], 64))
}
}

})